import { useEffect, useState } from "react";

// One clock for the whole page. Every card reading the time subscribes to the
// same tick, so a rail of cards costs one timer rather than one each — and the
// reading is a minute old at worst.
const TICK = 60_000;

const listeners = new Set();
let timer = null;

const watch = (listener) => {
  listeners.add(listener);
  if (!timer) timer = setInterval(() => listeners.forEach((fn) => fn(new Date())), TICK);
  return () => {
    listeners.delete(listener);
    if (!listeners.size && timer) {
      clearInterval(timer);
      timer = null;
    }
  };
};

/** The current time, kept fresh by the minute. */
export default function useNow() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => watch(setNow), []);
  return now;
}